import { userConstants } from '../_constants';

export function user(state = {}, action) {

      switch (action.type) {

        case userConstants.CHANGE_PASSWORD_REQUEST:
            return {
                passwordChanging: true
            };
        case userConstants.CHANGE_PASSWORD_SUCCESS:
            console.log("status: " + JSON.stringify(action.status));
            console.log("passwordChanged: " + action.status.statusCode === 0 ? false : true);
            return {
                status: action.status
            };
        
        case userConstants.CHANGE_PASSWORD_FAILURE:
            return {
                error: action.error
            };
       case userConstants.CS2_SPECS_DOWNLOAD_SUCCESS:
            return {};
        
        case userConstants.CS2_SPECS_DOWNLOAD_FAILURE:
            return {
                error: action.error
            };
       case userConstants.GET_VERSION_SUCCESS:
            return {
                version: action.version
            };
        
        case userConstants.GET_VERSION_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}